import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { IceLocalGame } from '../game/ice/IceLocalGame';
import { createIceGameStore } from '../game/ice/store';
import { parseSeed, randomSeed } from '../game/mountain';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * Two players on one screen, on the ice. The lake lives in the URL (`?lake=482193`) so a refresh
 * or a shared link gives the same lake. Cracks get a fresh seed every game, so nobody can learn
 * them.
 */
export function PlayIce() {
  const [params, setParams] = useSearchParams();
  const seed = parseSeed(params.get('lake'));
  useDocumentTitle('Play');

  useEffect(() => {
    if (seed === null) setParams({ lake: String(randomSeed()) }, { replace: true });
  }, [seed, setParams]);

  if (seed === null) return null;
  return (
    <IceGameRoute
      key={seed}
      seed={seed}
      onNewLake={() => setParams({ lake: String(randomSeed()) })}
    />
  );
}

function IceGameRoute({ seed, onNewLake }: { seed: number; onNewLake: () => void }) {
  const [store] = useState(() => createIceGameStore(seed, randomSeed()));
  return (
    <IceLocalGame
      store={store}
      onNewLake={onNewLake}
      onReplay={() => store.getState().start(seed, randomSeed())}
    />
  );
}
